import React from 'react';

import Label from '../Labels/Label';

import MultiSelectDropdown from '../BasicDropdown/MultiSelectDropdown';

import { getUserDisplayName } from '../../../utils/name_utils';

// TODO - Make sure the workspace owner is an object with user data
const transformWorkspacesToDropdownItems = workspaces => workspaces.map(workspace => ({
  id: workspace?.id,
  label: workspace?.name,
  render: ({ label }) => (
    <div className="flex flex-col">
      <Label className="font-medium text-base">{label}</Label>
      {
        workspace?.owner && (
          <Label className="mt-1 font-normal" size="sm">{getUserDisplayName(workspace.owner)}</Label>
        )
      }
    </div>
  ),
}))

export const WorkspaceSelectionDropdown = ({
  workspaces = [],
  selectedWorkspaces = [],
  setSelectedWorkspaces = () => {},
}) => {
  const workspaceItems = transformWorkspacesToDropdownItems(workspaces);
  return (
    <MultiSelectDropdown
      values={workspaceItems}
      selectedValues={selectedWorkspaces}
      setSelectedValues={setSelectedWorkspaces}
      formatSelectionCount={items => `${items.length} workspaces`}
      hideLabelInSmallViewports={false}
      search
    />
  )
}

export default WorkspaceSelectionDropdown;
